window.Prospection = {

	initFunnels: function (isAdmin) {
		$('#prefsMenu').height($('#contentDiv').outerHeight());
		MyFacture.customForm();
		if (isAdmin === 'Y') {

			$('#funnels tbody').sortable({
				axis		: 'y',
				handle		: 'td',
				placeholder	: "ui-state-highlight",
				stop		: function (event, ui) {
					
					var i			= 1;
					var funnelsSort = {};
					
					$("#funnels tbody tr").each(function (key, value) {
						funnelsSort[i] = $(this).attr('id');
						i++;
					});
					
					MyFacture.post(
						'prospection_prefs',
						{
							action: 'updateFunnelOrder',
							funnelsSort: funnelsSort
						},
						function (data) {
							if (data.success !== 'Y') {
								MyWindow.alert(Loc.g('Une erreur est survenue lors de la mise à jour des pipelines, merci de renouveler l‘opération dans quelques instants.'), {type: 'error'});
							}
						},
						'json'
					);
				}
			});

		}
	},

	initPrefsNum: function () {
		
		$('#prefsMenu').height($('#contentDiv').outerHeight());
		
		var formId	= "prefsNumForm";
		var options = {
			data	: {
				action : 'numRecord'
			},
			success: function (data) {
				Prospection.prefsNumCallback(data);
			},
			dataType: "json"
		};
		
		MyForm.prepare(formId, "prospection_prefs", options, true);
		MyFacture.customForm();
	},

	prefsNumCallback: function (data) {
		
		var formIsOk = MyForm.processJson(data, "prefsNumForm");
		
		if (formIsOk) {
			MyWindow.alert(Loc.g('Vos informations ont bien été mises à jour'), {type: 'confirm'});
		}
	},

	initPrefsMaj: function () {
		
		$('#prefsMenu').height($('#contentDiv').outerHeight());
		$("#prefsMajForm input[type='submit']").removeAttr('disabled');

		var formId	= "prefsMajForm";
		var options = {
			data	: {
				action : 'updateOpp'
			},
			success: function (data) {
				Prospection.prefsMajCallback(data);
			},
			dataType: "json"
		};

		MyForm.prepare(formId, "prospection_prefs", options, true);
		MyFacture.customForm();
	},

	prefsMajCallback: function (data) {
		
		var formIsOk = MyForm.processJson(data, "prefsMajForm");
		if (formIsOk) {
			MyWindow.alert(Loc.g('Vos informations ont bien été mises à jour'), {type: 'confirm'});
		}
	},

	addFunnelStep: function (funnelid) {
		
		var rand = Math.ceil(Math.random() * 100000);

		var html = '<li class="form-group">'
            + '<a href="javascript:;" class="handler" style="margin-right:10px;opacity:.55;vertical-align:-5px;"><img src="/ressources/logged/img/common/nsew-arrow.png" /></a>'
            + '<input type="text" id="sname_' + rand + '" name="steps[' + rand + '][label]" value=""  class="form-input"/>'
            + '<div class="form-label label-auto mx-2"> - ' + Loc.g('Probabilité') + ' </div>'
            + '<div class="form-input"><div class="input-addon append">%</div>'
            // + '<input type="text" style="width:40px;" id="sproba_' + rand + '"  name="steps[' + rand + '][proba]" value="" />'
            + '<select id="sproba_' + rand + '"  name="steps[' + rand + '][proba]">';
			for(var i = 0; i <= 100; i += 10){
                html += '<option value="'+i+'">'+i+'</option>'
			}

        	html += '</select>'
            + '</div>'
            + '<input type="hidden" name="steps[' + rand + '][id]" value="" />'
            + '<a href="javascript:;" onclick="Prospection.removeStep(this);" class="form-label label-auto ml-2"><i class="fa fa-trash-o fa-15"></i></a>'
            + '</li>';

		$('#steps').append(html);
	},

	setDefaultFunnel: function (fid) {
		MyFacture.post(
			'prospection_prefs',
			{
				action: 'setDefaultFunnel', 
				funnelid: fid
			},
			function (data) {
                location.reload()
            },
			'json'
		);
	},

	removeStep: function (elt) {
		$(elt).parent().remove();
	},

	deleteStep: function (id) {
		MyFacture.post(
			'prospection_prefs',
			{
				action: 'isStepDeletable', 
				stepid: id
			},
			function (data) {
				if (data.nbOpportunities > 0) {
					MyWindow.alert(Loc.g('Cette étape est utilisée dans') + ' ' + data.nbOpportunities + ' ' + Loc.g('opportunités'));
				} else {
					$('#step-' + id).fadeIn('fast', function () {
						$(this).remove();
					});
				}
			},
			'json'
		);
	},

	editFunnel: function (fid) {

		var funnelid	= fid !== undefined ? fid : '';
		var title		= fid !== undefined ? Loc.g('Modification du pipeline') : Loc.g('Ajout d‘un pipeline');

		var options = {
			title	: title,
			buttons	: [
				{
					text	: Loc.g("Annuler"),
					click	: function () {
						$(this).dialog("close");
					}
				},
				{
					text	: Loc.g("Enregistrer"), 
					click	: function () {
						$("#funnelForm").submit();
					}
				}
			],
			callback: function () {
				Prospection.prepareFunnelForm();
			}
		};
		MyWindow.load('prospection_prefs', {action: 'funnelForm', fid: funnelid}, options);
	},

	loadPopupCheckingEmail: function ()
	{
		window.sellsyapp.config.globalProperties.$store.state.popupPanel.popupCheckSendingEmail.props = { mode: 'checking'}
		window.sellsyapp.config.globalProperties.$store.state.popupPanel.popupCheckSendingEmail.display = true
	},
	
	prepareFunnelForm: function () {
		var formId	= "funnelForm";
		var options = {
			data	: {
				action : 'recordFunnel'
			},
			success: function (data) {
				Prospection.recordFunnelCallback(data);
			},
			dataType: "json"
		};
		
		MyForm.prepare(formId, "prospection_prefs", options, true);
		MyFacture.customForm();

		$('#steps').sortable({
			axis	: 'y',
			handle	: '.handler'
		});
	},

	recordFunnelCallback: function (data) {
		
		var formIsOk = MyForm.processJson(data, "funnelForm");
		if (formIsOk) {
			Utils.reload();
		} else {
			if (data.form.msg !== '') {
				MyWindow.alert(data.form.msg, {type: 'error'});
			} else {
				MyWindow.alert(Loc.g('Une erreur est survenue !'), {type: 'error'});
			}
		}
	},

	duplicateFunnel: function (fid) {

		var funnelid	= fid !== undefined ? fid : '';
		var options		= {
			type		: "warning",
			resizable	: false,
			noclose		: true,
			title		: Loc.g("Duplication"),
			buttons: [
				{
					text	: Loc.g("Annuler"),
					click	: function () {
						$(this).dialog("close");
					}
				},
				{
					text	: Loc.g("Dupliquer"),
					click	: function () {
						// action
						Prospection.duplicateFunnelRecord(funnelid);
						$(this).dialog("close");
					}
				}
			]
		};

		MyWindow.alert(Loc.g('Êtes-vous sûr de vouloir dupliquer ce pipeline ? Les automations liées à ce pipeline seront également dupliquées.'), options);
	},

	duplicateFunnelRecord: function (fid) {
		var datas = {
			action	: "duplicateFunnelRecord",
			funnelid: fid
		};

		MyFacture.post(
			"prospection_prefs", 
			datas, 
			function (data) {
				if (data.success === 'Y') {
					Utils.reload();
				} else {
					MyWindow.alert(Loc.g('Une erreur est survenue lors de la duplication !'), {type: 'error'});
				}
			}, 
			"json"
		);

	},

	getStepsForFunnel: function (selectPipelineId, selectStepsId, options) {
		
		var defaultOptions = {
			optionAll: false
		};

		options				= $.extend({}, defaultOptions, options);
		var selectpipeline	= typeof (selectPipelineId) === "undefined" ? "#po_funnelid" : "#" + selectPipelineId;
		var selectsteps		= typeof (selectStepsId) === "undefined" ? "#po_stepid" : "#" + selectStepsId;

		var selectPipelineElement	= $(selectpipeline);
		var selectStepsElement		= $(selectsteps);

		MyFacture.post(
			'prospection_opportunity', 
			{
				action	: 'getStepsForFunnel', 
				funnelid: selectPipelineElement.val()
			}, 
			function (data) {

				selectStepsElement.empty();

				if (options.optionAll) {
					selectStepsElement.append('<option value="" select="selected">' + (options.optionAllLabel ? options.optionAllLabel : '  --  ') + '</option>');
				}

				var cpt = 0;
				for (var i in data.steps) {
					cpt++;

					var automationTxt = Loc.g('Automation désactivée');
					if (data.steps[i].automationEnabled === 'Y') {
						automationTxt = Loc.g('Automation activée');
					}
					selectStepsElement.append('<option value="' + data.steps[i].id + '" proba="' + data.steps[i].proba + '">' + cpt + " - " + data.steps[i].label + ' - ' + automationTxt + '</option>');
				}

				selectStepsElement.trigger('change');
			},
			'json'
		);

	},

	editFunnelAutomation: function (fid, sid) {

		var options = {
			title	: Loc.g("Paramétrage de l’envoi d’email automatique pour le pipeline"),
			width	: 950,
			buttons	: [
				{
					text	: Loc.g("Annuler"),
					click	: function () {
						$(this).dialog("close");
					}
				},
				{
					text	: Loc.g("Enregistrer"), 
					click	: function () {
						$("#funnelAutomationForm").submit();
					}
				}
			],
			callback: function () {
				Prospection.prepareEditFunnelAutomation();
				Email.addListenerEmailVerified();
			}
		};
		MyWindow.load('prospection_prefs', {action: 'funnelAutomationForm', fid: fid, sid: sid}, options);

	},

	prepareEditFunnelAutomation: function () {

		var formId	= "funnelAutomationForm";
		var options = {
			data	: {
				action : 'recordFunnelAutomationForm'
			},
			success	: function (data) {
				var formIsOk = MyForm.processJson(data, "funnelAutomationForm");
				if (formIsOk) {
					Utils.reload();
				} else {
					if (data.form.msg !== '') {
						MyWindow.alert(data.form.msg, {type: 'error'});
					}
				}
			},
			dataType: "json"
		};

		MyForm.prepare(formId, "prospection_prefs", options, true);
		MyFacture.customForm();

		$.mask.definitions['5'] = '[0-5]';
		$('#' + formId).find(".automationTime").mask("99:00", {placeholder: "-", replacement: '0'});

	},

	addFunnelAutomation: function (funnelId) {

		var nbFunnelAutomation	= $('.funnelStep_' + funnelId + ' tr').length;
		var newId				= nbFunnelAutomation;
		var template			= $('#funnelAutomationForm .funnalAutomationTemplate tbody').clone();

		if ($('.funnelStep_' + funnelId + ' tr:visible:last').length > 0) {

			if ($('.funnelStep_' + funnelId + ' tr:visible:last').find(".automationDay").val() === undefined) {
				template.find('.automationDay').attr('value', 1);
			} else {
				template.find('.automationDay').attr('value', parseInt($('.funnelStep_' + funnelId + ' tr:visible:last').find(".automationDay").val(), 10) + 1);
				template.find('.automationHour').attr('value', $('.funnelStep_' + funnelId + ' tr:visible:last').find(".automationHour").val());
			}

		}

		template.find('.funnalAutomationDeleted')
				.attr('name', "funnelAutomation_automations[" + funnelId + "][steps][" + newId + "][deleted]")
				.attr('id', "funnelAutomation_automations_" + funnelId + "_steps_" + newId + "_deleted");

		template.find('.automationDay')
				.attr('name', "funnelAutomation_automations[" + funnelId + "][steps][" + newId + "][day]")
				.attr('id', "funnelAutomation_automations_" + funnelId + "_steps_" + newId + "_day");

		template.find('.automationHour')
				.attr('name', "funnelAutomation_automations[" + funnelId + "][steps][" + newId + "][hour]")
				.attr('id', "funnelAutomation_automations_" + funnelId + "_steps_" + newId + "_hour");

		template.find('.selectEmailTemplate')
				.attr('name', "funnelAutomation_automations[" + funnelId + "][steps][" + newId + "][emailTemplate]")
				.attr('id', "funnelAutomation_automations_" + funnelId + "_steps_" + newId + "_emailTemplate");

        template.find('.selectStaffSendType')
            .attr('name', "funnelAutomation_automations[" + funnelId + "][steps][" + newId + "][sendertype]")
            .attr('id', "funnelAutomation_automations_" + funnelId + "_steps_" + newId + "_sendertype")
            .attr('onchange', "Automation.disabledExpediteurSelect($(this), 'funnelAutomation_automations_" + funnelId + "_steps_" + newId + "_senderstaffid')");

		template.find('.selectStaffSendId')
				.attr('name', "funnelAutomation_automations[" + funnelId + "][steps][" + newId + "][senderstaffid]")
				.attr('id', "funnelAutomation_automations_" + funnelId + "_steps_" + newId + "_senderstaffid");


		$('.funnelStep_' + funnelId + " .funnelAutomationStepContainer tbody").append(template.html());

		$.mask.definitions['5'] = '[0-5]';
		$('.funnelStep_' + funnelId + " .funnelAutomationStepContainer").find(".automationTime").mask("99:00", {placeholder: "-", replacement: '0'});

		MyFacture.customForm();

	},

	removeFunnelAutomation: function (me) {
		me.closest('tr').hide().find('.funnalAutomationDeleted').val('Y');
	},

	editSource: function (sid) {

		var sourceid	= sid !== undefined ? sid : '';
		var title		= sid !== undefined ? Loc.g('Modification de la source') : Loc.g('Ajout d‘une source');

		var options = {
			title	: title,
			width	: 600,
			buttons	: [
				{
					text: Loc.g("Annuler"), 
					click: function () {
						$(this).dialog("close");
					}
				},
				{
					text: Loc.g("Enregistrer"), 
					click: function () {
						$("#sourceForm").submit();
					}
				}
			],
			callback: function () {
				Prospection.prepareSourceForm();
			}
		};
		MyWindow.load('prospection_prefs', {action: 'sourceForm', sid: sourceid}, options);
	},

	prepareSourceForm: function () {
		var formId	= "sourceForm";
		var options = {
			data	: {
				action	: 'recordSource'
			},
			success	: function (data) {
				Prospection.recordSourceCallback(data);
			},
			dataType: "json"
		};
		
		MyForm.prepare(formId, "prospection_prefs", options, true);
		MyFacture.customForm();
	},

	recordSourceCallback: function (data) {
		var formIsOk = MyForm.processJson(data, "sourceForm");
		if (formIsOk) {
			Utils.reload();
		}
	},

	setDefaultSource: function (sid) {
		
		MyFacture.post(
			'prospection_prefs',
			{
				action	: 'setDefaultSource', 
				sourceid: sid
			},
			function (data) {
				$('#sources .sourceDefault').addClass('hidden');
                $('#sources #source_' + sid + ' .actionSource .sourceDefault').removeClass('hidden');
                Utils.reload();
			},
			'json'
		);
	},

	deleteSource: function (sid) {
		var options = {
			resizable	: false,
			noclose		: true,
			title		: Loc.g("Suppression d'une source"),
			buttons		: [
				{
					text: Loc.g("Annuler"), 
					click: function () {
						$(this).dialog("close");
					}
				},
				{
					text: Loc.g("Supprimer"),
					click: function () {
						Prospection.doDeleteSource(sid);
						$(this).dialog("close");
					}
				}
			]
		};

		MyWindow.alert(Loc.g("Toute les opportunités attachées à la source n'auront plus de source. Valider pour supprimer la source."), options);
	},

	doDeleteSource: function (sid) {
		MyFacture.post(
			"prospection_prefs", 
			{
				action	: "deleteSource", 
				sid		: sid
			}, 
			function (data) {
				Utils.reload();
			}, 
			"json"
		);
		return true;
	},

	toggleHideInSelect: function (id, state, object) {
		var title = msgAlert = '';

		switch (object) {
			case 'source':
				title		= state === 'Y' ? Loc.g("Masquer la source") : Loc.g("Afficher la source");
				msgAlert	= state === 'Y' ? Loc.g("La source ne sera plus disponible dans les listes (ex : lors de la création d'une opportunité).<br/><br/><strong>Attention, si des opportunités sont liées à cette source, lors de la modification d’une de ces opportunités, vous n’aurez plus la possibilité de lier l’opportunité à cette source.</strong>")
								: Loc.g("La source sera disponible dans les listes (ex : lors de la création d'une opportunité)");
				break;
			case 'funnel':
				title		= state === 'Y' ? Loc.g("Masquer le pipeline") : Loc.g("Afficher le pipeline");
				msgAlert	= state === 'Y' ? Loc.g("Le pipeline ne sera plus disponible lors de la création d’une opportunité mais restera disponible dans les filtres.<br/><br/><strong>Attention, si des opportunités sont liées à ce pipeline, lors de la modification d’une de ces opportunités, vous n’aurez plus la possibilité de lier l’opportunité à ce pipeline.</strong>")
								: Loc.g("Le pipeline sera disponible dans les listes (ex : lors de la création d'une opportunité)");
				break;

		}

		var options = {
			type		: 'warning',
			resizable	: false,
			noclose		: true,
			title		: title,
			buttons		: [
				{
					text: Loc.g("Annuler"),
					click: function () {
						$(this).dialog("close");
					}
				},
				{	
					text: state === 'Y' ? Loc.g("Masquer") : Loc.g("Afficher"),
					click: function () {
						Prospection.doToggleHideInSelect(id, state, object);
						$(this).dialog("close");
					}
				}
			]
		};

		MyWindow.alert(msgAlert, options);
	},

	doToggleHideInSelect: function (id, state, object) {
		
		MyFacture.post(
			"prospection_prefs",
			{
				action	: "toggleHideInSelect", 
				id		: id, 
				state	: state, 
				object	: object
			}, 
			function (data) {
				if (data.success === 'Y') {
					switch (object) {
						case 'source':
							if (state === 'Y') {
								$('#source_' + id + ' .actionSource .showInSelect').removeClass('hide');
								$('#source_' + id + ' .actionSource .hideInSelectAction').addClass('hide');
								$('#source_' + id + ' .actionSource .showInSelectAction').removeClass('hide');
							} else {
								$('#source_' + id + ' .actionSource .showInSelect').addClass('hide');
								$('#source_' + id + ' .actionSource .hideInSelectAction').removeClass('hide');
								$('#source_' + id + ' .actionSource .showInSelectAction').addClass('hide');
							}
							break;
						case 'funnel':
							Utils.reload();
							break;
					}
				} else {
					MyWindow.alert(data.msg, {type: 'error'});
				}
			},
			"json"
		);
		return true;
	},

	deleteFunnel: function (fid) {
		var options = {
			resizable	: false,
			noclose		: true,
			title		: Loc.g("Suppression d‘un pipeline"),
			buttons		: [
				{
					text: Loc.g("Annuler"), 
					click: function () {
						$(this).dialog("close");
					}
				},
				{
					text	: Loc.g("Valider"),
					click	: function () {
						Prospection.doDeleteFunnel(fid);
						$(this).dialog("close");
					}
				}
			]
		};

		MyWindow.alert(Loc.g("Toute les opportunités attachées au pipeline n'auront plus d'étapes. Valider pour supprimer le pipeline."), options);
	},

	doDeleteFunnel: function (fid) {
		MyFacture.post(
			"prospection_prefs", 
			{
				action	: "deleteFunnel", 
				fid		: fid
			},
			function (data) {
				Utils.reload();
			}, 
			"json"
		);
		return true;
	},

	actionGroupOpp: function (indice) {

		// Prospect list
		$("#prospectList li a.link").removeClass("link");
		$("#prospectList li#prospect_" + indice + " a").addClass("link");

		// Form
		// Delay => cause jquery is randomly a f***ing dumbass with callback method !
		$("#contentPan .panForm:not(#panForm_" + indice + ")").hide();
		$("#contentPan #panForm_" + indice).delay(300).fadeIn(300, function () {
			MyFacture.customForm("#panForm_" + indice);
		});

	}
};

window.ProspectionPrefs = {

	init: function () {
		$(document).mouseup(function (e) {
			var container = $(".dropdown");
			if (container.has(e.target).length === 0)
				container.hide();
		});
		
		ProspectionPrefs.initDragDrop();
	},

	initDragDrop: function () {

		$(".sourcesList.droptrue").sortable({
			connectWith: ".sourcesList",
			axis: "y",
			start: function (event, ui) {
				$('#sources .sourcesListCategory .sourcesList').css('min-height', '10px');

				var ui			= $(ui);
				var oldcat		= ui[0].item.closest('.source-category');
				var oldcatid	= oldcat.prop('id');
				var nbSources	= $('#' + oldcatid + ' .nbSourcesCategory').text();
				var newNbSource = parseInt(nbSources) - 1;
				
				$('#' + oldcatid + ' .nbSourcesCategory').html(newNbSource);
			},
			stop: function (event, ui) {

				$('#sources .sourcesListCategory .sourcesList').css('min-height', '0px');

				var ui			= $(ui);
				var cat			= ui[0].item.closest('.source-category');

				var catid		= cat.prop('id');
				var nbSources	= $('#' + catid + ' .nbSourcesCategory').text();
				var newNbSource = parseInt(nbSources) + 1;
				$('#' + catid + ' .nbSourcesCategory').html(newNbSource);


				var datas = Object();
				cat.find('.sourcesListCategory > .sourcesList > .sourceDrag').each(function (key, value) {

					datas[key] = {
						rank	: key,
						id		: $(value).data('id'),
						catid	: cat.prop('id')
					};
				});

				MyFacture.post("prospection_prefs", {action: 'updateSource', datas: datas}, function (data) {
					if (data.status === 'ok') {

						cat.find('.sourcesListCategory > .sourcesList > .sourceDrag').each(function (key, value) {

							$(value).find('.iconCategory').css('border', '1px solid #' + cat.data('color'));
							$(value).find('.iconCategory > i').css('color', '#' + cat.data('color'));
							$(value).find('.iconCategory > i').removeClass();
							$(value).find('.iconCategory > i').addClass('fa ' + cat.data('icon'));
						});
					} else {
						var options = {
							type		: "error",
							resizable	: false,
							noclose		: true,
							title		: Loc.g("Erreur lors de l'enregistrement"),
							buttons		: [
								{
									text: Loc.g("OK"),
									click: function () {
										$(this).dialog("close");
									}
								}
							]
						};
						MyWindow.alert(Loc.g("Erreur lors de l'enregistrement, veuillez ré-essayer ultérieurement."), options);
					}
				}, "json");

			}
		});
	},

	sourcesCategoryForm: function (id) {

		var title = id === undefined ? Loc.g('Ajouter une catégorie') : Loc.g('Modifier une catégorie');

		var options = {
			title	: title,
			width	: 600,
			buttons	: [
				{
					text: Loc.g("Annuler"), 
					click: function () {
						$(this).dialog("close");
					}
				},
				{
					text: Loc.g("Enregistrer"), 
					click: function () {
						$("#sourcesCategoryForm").submit();
					}
				}
			],
			callback: function () {
				ProspectionPrefs.prepareSourcesCategoryForm();
			}
		};

		MyWindow.load("prospection_prefs", {action: "sourcesCategoryForm", id: id}, options);

	},

	prepareSourcesCategoryForm: function () {

		$('.colorpicker').colpick({
			layout		: 'hex',
			submit		: 0,
			colorScheme	: 'light',
			onChange	: function (hsb, hex, rgb, el, bySetColor) {
				
				var blockID = $(el).closest('form').find('input[name=sourcescat_color]').val();

				$('#colorPreview').css('background-color', '#' + hex);
				// Fill the text box just if the color was set using the picker, and not the colpickSetColor function.
				$(el).val(hex);
			}
		}).unbind('keyup').keyup(function () {
			$(this).colpickSetColor(this.value);
		}).trigger('keyup');

		$('#sourcescat_icon').iconpicker({
			title: Loc.g('Choisissez une icône'),
			mustAccept: true
		});

		var formId	= "sourcesCategoryForm";
		var options = {
			data	: {
				action: 'recordsourcesCategoryForm'
			},
			success: function (data) {
				var formIsOk = MyForm.processJson(data, "sourcesCategoryForm");
				if (formIsOk) {
					MyWindow.close();
					Utils.reload();
				}
			}, 
			dataType: "json"
		};

		MyForm.prepare(formId, "prospection_prefs", options, true);
		MyFacture.initEvent();
		MyTabs.initHorizontal('sourcesCategoryForm');

	},

	sourcesCategoryDeleteForm: function (id) {

		var options = {
			title: Loc.g('Supprimer une catégorie'),
			buttons: [
				{
					text: Loc.g("Annuler"),
					click: function () {
						$(this).dialog("close");
					}
				},
				{
					text: Loc.g("Supprimer"),
					click: function () {
						$(this).dialog("close");
						MyFacture.post("prospection_prefs", {action: "sourcesCategoryDeleteForm", id: id}, function (data) {
							Utils.reload();
						}, "json");
					}
				}
			]
		};

		MyWindow.load("prospection_prefs", {action: "deletesourcesCategoryForm", id: id}, options);

	},

	switchSourceAddForm: function (element) {

		var $sourcePart = $('#sourceCatPart');
		var checked = $('input[type="radio"]:checked', $sourcePart).val();

		switch (checked) {

			case 'newCat':

				ProspectionPrefs.loadPieceForForm('newCatPop', {
					success: Opportunity.callbacks.afterNewProspectShowing
				});
				$('#sourceCatPart .categorySelect').css('display', 'none');

				break;

			default:

				var $newCatPop = $('#newCatPop', $sourcePart);

				if ($newCatPop.is(':visible')) {
					$newCatPop.slideUp(200);
				}
				$('#sourceCatPart .categorySelect').css('display', 'block');

				break;

		}

	},

	loadPieceForForm: function (formID, options) {

		options = !_.isUndefined(options) ? options : {};

		return $.ajax({
			url		: '/?_f=prospection_prefs',
			dataType: 'html',
			data	: {
				action: 'formAddCat'
			},
			beforeSend: function () {

				// $('.newThirdForm:not(#'+formID+')').empty();
				MyWindow.wait();

				if (_.isFunction(options.beforeSend)) {
					options.beforeSend();
				}

			},
			success: function (data) {

				$('#' + formID).html(data).slideDown(200, function () {
					MyFacture.customForm('#' + formID);
				});

				$('.colorpicker').colpick({
					layout: 'hex',
					submit: 0,
					colorScheme: 'light',
					onChange: function (hsb, hex, rgb, el, bySetColor) {
						var blockID = $(el).closest('form').find('input[name=sourcescat_color]').val();

						$('#colorPreview').css('background-color', '#' + hex);
						// Fill the text box just if the color was set using the picker, and not the colpickSetColor function.
						$(el).val(hex);
					}
				}).unbind('keyup').keyup(function () {
					$(this).colpickSetColor(this.value);
				}).trigger('keyup');

				$('#sourcescat_icon').iconpicker({});

				if (_.isFunction(options.success)) {
					options.success(data);
				}

			},
			complete: function () {
				MyWindow.awake();
			}
		});
	}
};


